// In order to use this entity make sure you correctly require/import the `RoutesService` and
// devex.util

angular
  .module('models.JobMinimalModel', [])
  .service('JobMinimalModel', [
    '$filter',
    'RoutesService',
    function ($filter, Routes) {
      const today = 1;
      const week = 7;

      /**
       * Checks if the job is closing this week
       *
       * @param {string} closingDate - Closing date field
       *
       * @returns {boolean} - True if job is closing in less than 7 days, false if date is closing
       *                      in more than a week or if no closingDate passed
       */
      const isClosingThisWeek = closingDate => {
        if(!closingDate) {
          return false;
        }

        const closingIn = devex.util.differenceInDays(new Date(), new Date(closingDate));

        return closingIn <= week;
      };

      /**
       * Formats the closing date into a user-friendly format
       *
       * @param {string} date - Closing date field
       *
       * @returns {string} - Formatted humanized closing date, to be shown in the view
       */
      const formatClosingDate = date => {
        const closingDate = new Date(date);

        const closingIn = devex.util.differenceInDays(new Date(), closingDate);

        if(!closingIn) {
          return 'Closing today';
        } else if(closingIn === today) {
          return 'Closing in 1 day';
        } else if(closingIn <= week) {
          return `Closing in ${ closingIn } days`;
        }

        return $filter('date')(closingDate, 'd MMM yyyy');
      };

      return class JobMinimalModel {
        constructor(data) {
          if(data.closing_date) {
            this.closingDate = data.closing_date;
            this.isClosingThisWeek = isClosingThisWeek(data.closing_date);
            this.formattedClosingDate = formatClosingDate(data.closing_date);
          }

          this.id = data.id;
          this.name = data.name;
          this.employer = data.employer_company.name;

          this.link = Routes.job_path({ id: this.id });
        }
      };
    }
  ]);
